<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h500_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item
                    label="活动名称"
                    prop="activityName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.activityName"
                      disabled
                    >
                      <el-button
                        v-if="eventType==='add'"
                        slot="append"
                        icon="el-icon-search"
                        @click="dialogActivityVisible=true"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-if="eventType!=='view'"
                      v-model="dialogAddEditViewForm.provinceId"
                      filterable
                      clearable
                      placeholder="请选择省区"
                      style="width:100%"
                      disabled
                      @change="changeProvinceFun"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                    <el-input
                      v-else
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="所属小程序"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.appletTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="类型"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.sortStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="兑换名称"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="开始日期"
                    prop="startDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.startDate"
                      disabled
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="结束日期"
                    prop="endDate"
                  >
                    <el-date-picker
                      v-model="dialogAddEditViewForm.endDate"
                      disabled
                      type="date"
                      style="width: 100%;"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  v-if="dialogAddEditViewForm.sort === 1"
                  :span="6"
                >
                  <el-form-item
                    label="兑换积分"
                    prop="integral"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.integral"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogAddEditViewForm.sort === 2"
                  :span="6"
                >
                  <el-form-item
                    label="中奖率(例10%，请输入0.1)"
                    prop="winRate"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.winRate"
                      :disabled="eventType==='view'"
                      @input="(val)=>{limitPositiveNumber(val, dialogAddEditViewForm, 'winRate')}"
                      @blur="setNumberValueDefaultZero($event, dialogAddEditViewForm, 'winRate', 4);"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="dialogAddEditViewForm.sort === 1 ? '兑换数量' : '中奖总数量'"
                    prop="amount"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.amount"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="eventType === 'view'"
                  :span="6"
                >
                  <el-form-item
                    label="剩余数量"
                  >
                    <el-input
                      v-model.number="dialogAddEditViewForm.leftAmount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      style="margin-top:10px;"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
    <activity-list-dialog
      :dialog-visible.sync="dialogActivityVisible"
      dialog-title="活动信息"
      @selectedActivityFun="selectedActivityFun"
    />
  </div>
</template>
<script>
// 数据请求
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 设置input值为数字
import setNumberMixin from '@/mixin/setNumberMixin'
// 活动
import activityListDialog from './activityListDialog'
import { loadAreaDataApi } from '@/api/area'
import { initAppConsumerIntegralExchangeSettingApi, saveOrUpdateAppConsumerIntegralExchangeSettingApi } from '@/api/appConsumerIntegralExchangeSetting'
export default {
  components: { activityListDialog },
  mixins: [dialogDragMixin,setNumberMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {
      },
      dialogAddEditViewFormRules: {
        activityName: [ { required: true, message: '请选择活动', trigger: 'change' }],
        provinceId: [ { required: true, message: '请选择省区', trigger: 'change' }],
        startDate: [ { required: true, message: '请选择开始时间', trigger: 'change' }],
        endDate: [ { required: true, message: '请选择结束时间', trigger: 'change' }],
        name: [ { required: true, message: '请输入名称', trigger: 'blur' },{ max: 64, message: '最多输入64个字符', trigger: 'blur' }],
        integral: [ { type: 'number', required: true, message: '积分必须为数字值', trigger: 'blur' }],
        winRate: [ { required: true, message: '请输入中奖率', trigger: 'blur' }],
        amount: [ { type: 'number', required: true, message: '数量必须为数字值', trigger: 'blur' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' } ]
      },
      provinceOptions: [],
      dialogActivityVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.dialogAddEditViewForm.clearValidate()
        })
        this.loading = true
        this.dialogAddEditViewForm = {
          activityName: '',
          provinceName: '',
          provinceId: '',
          name: '',
          startDate: '',
          endDate: '',
          appletType: 0,
          appletTypeStr: '',
          sort: 1,
          sortStr: '',
          integral: '',
          winRate: 0,
          amount: '',
          leftAmount: 0,
          status: 1,
          remark: ''
        }
        this.provinceOptions = []
        this.initProvinceSelectData()
        if (this.eventType !== 'add') {
          this.initConsumerIntegralExchangeSettingData()
        }
      }
    }
  },
  methods: {
    // 加载数据
    initConsumerIntegralExchangeSettingData () {
      initAppConsumerIntegralExchangeSettingApi({ id: this.dataId }).then(res => {
        const { data } = res
        for(let key in this.dialogAddEditViewForm){
          if(key !== 'startDate' && key !== 'endDate'){
            this.dialogAddEditViewForm[key] = data[key]
          }
        }
        this.dialogAddEditViewForm.startDate = data.startDateStr
        this.dialogAddEditViewForm.endDate = data.endDateStr
        if(this.eventType === 'view'){
          this.dialogAddEditViewForm.winRate = data.winRateStr
        }
        this.dialogAddEditViewForm.id = data.id
        this.loading = false
      })
    },
    // 初始省区下拉数据
    initProvinceSelectData(){
      loadAreaDataApi({ parentId: 1 }).then(res => {
        let resultData = res.data
        resultData.forEach(item => {
          this.provinceOptions.push({ label: item.name, data: item.id })
        })
        if(this.eventType === 'add') {
          this.loading = false
        }
      })
    },
    // 选择省区回调
    changeProvinceFun(val){
      let selectItem = {}
      selectItem = this.provinceOptions.find(item => {
        return item.data === val
      })
      this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
    },
    // 选择活动
    selectedActivityFun(val){
      this.dialogAddEditViewForm.activityId = val.id
      this.dialogAddEditViewForm.activityName = val.name
      this.dialogAddEditViewForm.provinceName = val.provinceName
      this.dialogAddEditViewForm.provinceId = val.provinceId
      this.dialogAddEditViewForm.startDate = val.startDateStr
      this.dialogAddEditViewForm.endDate = val.endDateStr
      this.dialogAddEditViewForm.sort = val.sort
      this.dialogAddEditViewForm.sortStr = val.sortStr
      this.dialogAddEditViewForm.appletType = val.appletType
      this.dialogAddEditViewForm.appletTypeStr = val.appletTypeStr
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    modalClose () {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          if(Number(this.dialogAddEditViewForm.startDate.replaceAll('-',"")) > Number(this.dialogAddEditViewForm.endDate.replaceAll('-',""))){
            this.$message({
              message: '开始日期不能大于结束日期',
              type: 'warning'
            })
            return false
          }
          this.$confirm(
            (this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '用户奖品设置','系统提示',
            {
              confirmButtonText: '确定',
              cancelButtonText:'取消',
              type: 'warning',
              center: true
            }
          )
            .then(async () => {
              this.loading = true
              this.dialogAddEditViewForm.leftAmount = this.dialogAddEditViewForm.amount
              if(this.dialogAddEditViewForm.sort === 1){
                this.dialogAddEditViewForm.winRate = 0
              } else if (this.dialogAddEditViewForm.sort === 2){
                this.dialogAddEditViewForm.integral = 0
              }
              this.handlerSave()
            })
            .catch(() => { })
        }
      })
    },
    // 保存
    handlerSave () {
      saveOrUpdateAppConsumerIntegralExchangeSettingApi(this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          this.$message({ message: res.message, type: 'success' })
          this.reloadData()
          this.modalClose()
        }
      }).catch(() => {
        this.loading = false
      })
    },
  }
}
</script>
<style lang="scss"  scoped>

</style>
